
import { request } from "@insite/client-framework/Services/ApiService";

export interface searchBlogparameter {
    searchQuery: string;
    onSuccess?: () => void;
    onError?: () => void;
}
export interface blogSearchModel  {
    [x: string]: any;
}
const pagesByParentUrl = "/api/V2/customcontentsearch/SearchBlogByName";

export async function getPagesByParent(searchQuery: string) {
    try {
        return await request<blogSearchModel>(`${pagesByParentUrl}?query=${searchQuery}`, "GET", {});
    } catch (error) {
        throw new Error("Failed to fetch pages by parent");
    }
}


